import React, { useEffect } from "react";

import Editor from './ABridTileNarrowEditor'
import EditorWrapper from '../../EditorWrapper'

import BridTile from "../../common/BridTileNarrow";
import { BridArticle } from "../../common/EmptyArticle";

const ATextOnPicture = props => {
    let article = BridArticle();
    const { settings } = props;
    const imageUrl = (settings['background-image'] ? settings['background-image'] : '');
    article.title = settings.title_normal;
    article.picture.img = window.MEDIA_DOMAIN + '/' + imageUrl.replace('.', ',780,0,0,0.');
    article.url = settings.link;
    article.label = settings.label;
    article.title_button1 = settings.title_button1
    article.title_button2 = settings.title_button2
    article.title_button3 = settings.title_button3
    article.article1_id = settings.article1_id
    article.article2_id = settings.article2_id
    article.article3_id = settings.article3_id
    article.time = settings.time;

    // linki dodatkowe
    settings.show_links = (settings.show_links ? settings.show_links : 'off');
    article.show_links = settings.show_links;
    article.links = settings.links;

    // props.onRegisterBox(props.blockId, props.id, 'title_normal')

    return (
        <div className={props.classes} {...props.events} >
            <EditorWrapper {...props} editor={Editor} />
            <BridTile {...props} article={article} size={props.size} imageHeight={props.imageHeight} preserveImageRatio={props.preserveImageRatio} />
        </div>
    );
};

export default ATextOnPicture;
